import React from "react";
import "./ai-champion.css";
import aiChampIcon from "../../assets/images/ai-champ.png";

const AiChampion = ({ theme }) => {
  return (
    <div
      style={{
        backgroundColor: theme === "dark" ? "#161616" : "#ffffff",
      }}
      className="ai-champion-container">
      <img src={aiChampIcon} alt="ai-champ-image" />
      <div
        style={{
          flex: "1",
          display: "flex",
          alignItems: "center",
          gap: "20px",
        }}>
        <h2 className="ai-champ-title">AI Companion:</h2>
        <div className="ai-champion-search-filter">
          <input
            style={{
              backgroundColor: theme === "dark" ? "#232323" : "#F4F7FE",
              border: theme === "dark" ? "#232323" : "#F4F7FE",
            }}
            type="text"
            name="search"
            // placeholder="How can I help you?"
            placeholder="Just getting my circuits warmed up... I'll be ready to help soon!"
          />
          <button onClick={() => {}}>Search</button>
        </div>
      </div>
    </div>
  );
};

export default AiChampion;
